import React from 'react';
import { FullTable, AddCircleBlue, CustomDelete } from 'components';
import { useModal } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import { payrollActions } from 'store';
import { MILEAGE_ACTION, mileageBody, mileageHead, TERMINATE_MILEAGE } from './constants';
import { MileageCompensation as MileageModal } from './modals';

export const MileageCompensationsList = ({ }) => {
    const mileages = useSelector((state) => state.payroll.mileages);
    const dispatch = useDispatch();
    const { open } = useModal();

    const handleOpen = (item, name) => {
        if (name === 'inactive') {
            open(
                <CustomDelete
                    info="Terminate mileage"
                    text="Are you sure you want to terminate this mileage?"
                    innerText="Inactivate"
                    handleDel={() => dispatch(payrollActions.terminateMileage(item?.id))}
                    actionType={TERMINATE_MILEAGE}
                />
            );
        } else {
            open(<MileageModal info={item} />);
        }
    };

    return (
        <div>
            <div className="header-action-btn" style={{ marginTop: '-24px' }}>
                <AddCircleBlue text="Add Mileage Compensation" handleClick={() => open(<MileageModal />)} />
            </div>
            <FullTable
                head={mileageHead}
                body={mileageBody(handleOpen)}
                loadingType={MILEAGE_ACTION}
                list={mileages?.length ? mileages : []}
                noText={'mileage compensations'}
                margin={'16px 0 0 0'}
            />
        </div>
    );
};
